import { CURRENCY_DECIMALS, CURRENCY_INFO, type Currency } from '../constants/currency/currency';
import type { ReferralMoney } from '../model/referral/referral';

export function convertReferralMoney(money: ReferralMoney | undefined, currency: string, rate: number | undefined) {
  const requiresConversion = Boolean(money && money.currency !== currency);
  const hasRate = typeof rate === 'number' && Number.isFinite(rate) && rate > 0;
  return {
    money:
      money && (!requiresConversion || hasRate)
        ? { amount: money.amount * (requiresConversion && hasRate ? rate : 1), currency }
        : undefined,
    requiresConversion,
  };
}

export function formatReferralMoney({ amount, currency }: ReferralMoney): string {
  const decimals = CURRENCY_DECIMALS[currency as Currency] ?? 2;
  const value = new Intl.NumberFormat('en', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
    .format(amount)
    .replace(/\.0+$/, '');
  const info = CURRENCY_INFO[currency as Currency];
  if (!info) {
    return `${currency} ${value}`;
  }
  return info.position === 'prefix' ? `${info.symbol}${value}` : `${value} ${info.symbol}`;
}

export function splitReferralMoneyLabel(label: string): { prefix: string; amount: string } {
  const match = label.length > 7 ? /^([A-Z]{2,})(.+)$/.exec(label) : null;
  if (!match) {
    return { prefix: '', amount: label };
  }
  const [, prefix, amount] = match;
  return { prefix, amount };
}
